import React from "react";

export default function SvgComponent() {
  return (
    <svg
      version="1.0"
      viewBox="0 0 187.5 187.5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="a">
          <path d="M32.91 32.91h121.5v121.5H32.91zm0 0" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path
          d="M154.41 93.66c0 33.55-27.2 60.75-60.75 60.75-33.547 0-60.75-27.2-60.75-60.75 0-33.547 27.203-60.75 60.75-60.75 33.55 0 60.75 27.203 60.75 60.75"
          fill="#ffcc4d"
        />
      </g>
      <path
        d="M91.34 92.352a1.688 1.688 0 00-2.059-.047c-.043.03-4.254 3.043-12.496 3.043-8.238 0-12.453-3.012-12.488-3.035a1.677 1.677 0 00-2.059.027 1.697 1.697 0 00-.496 2.008c.203.453 5.063 11.125 15.043 11.125 9.985 0 14.84-10.672 15.043-11.125a1.68 1.68 0 00-.488-1.996zm33.75 0a1.683 1.683 0 00-2.059-.047c-.043.03-4.258 3.043-12.496 3.043-8.234 0-12.453-3.012-12.488-3.035a1.677 1.677 0 00-2.059.027 1.697 1.697 0 00-.496 2.008c.203.453 5.063 11.125 15.043 11.125 9.985 0 14.84-10.672 15.043-11.125a1.68 1.68 0 00-.488-1.996zm-17.93 35.058h-27a3.373 3.373 0 01-3.375-3.375 3.373 3.373 0 013.375-3.375h27a3.37 3.37 0 013.375 3.375 3.37 3.37 0 01-3.375 3.375zm-54-47.25a3.376 3.376 0 01-.012-6.75c.528-.004 12.043-.289 20.942-12.148a3.38 3.38 0 014.726-.676 3.38 3.38 0 01.672 4.727C68.477 79.993 53.781 80.16 53.16 80.16zm81 0c-.62 0-15.312-.168-26.324-14.847a3.373 3.373 0 01.676-4.727 3.366 3.366 0 014.722.676c8.91 11.883 20.454 12.144 20.946 12.148a3.384 3.384 0 013.343 3.395 3.362 3.362 0 01-3.363 3.355zm0 0"
        fill="#664500"
      />
    </svg>
  );
}
